import { configureStore as S } from "@reduxjs/toolkit";
import P from "../reducers/AppReducer.js";
import { persistReducer as N, persistStore as I } from "redux-persist";
import { p as c } from "../../../index-xuotMAFm.js";
import { AppInitialState as w } from "../reducers/InitialState.js";
function D(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var p = {}, m = {}, g = {}, v;
function h() {
  if (v) return g;
  v = 1, g.__esModule = !0, g.default = s;
  function e(i) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(u) {
      return typeof u;
    } : e = function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, e(i);
  }
  function n() {
  }
  var r = {
    getItem: n,
    setItem: n,
    removeItem: n
  };
  function t(i) {
    if ((typeof self > "u" ? "undefined" : e(self)) !== "object" || !(i in self))
      return !1;
    try {
      var o = self[i], u = "redux-persist ".concat(i, " test");
      o.setItem(u, "test"), o.getItem(u), o.removeItem(u);
    } catch {
      return c.env.NODE_ENV !== "production" && console.warn("redux-persist ".concat(i, " test failed, persistence will be disabled.")), !1;
    }
    return !0;
  }
  function s(i) {
    var o = "".concat(i, "Storage");
    return t(o) ? self[o] : (c.env.NODE_ENV !== "production" && console.error("redux-persist failed to create sync storage. falling back to noop storage."), r);
  }
  return g;
}
var y;
function R() {
  if (y) return m;
  y = 1, m.__esModule = !0, m.default = r;
  var e = n(h());
  function n(t) {
    return t && t.__esModule ? t : { default: t };
  }
  function r(t) {
    var s = (0, e.default)(t);
    return {
      getItem: function(o) {
        return new Promise(function(u, a) {
          u(s.getItem(o));
        });
      },
      setItem: function(o, u) {
        return new Promise(function(a, f) {
          a(s.setItem(o, u));
        });
      },
      removeItem: function(o) {
        return new Promise(function(u, a) {
          u(s.removeItem(o));
        });
      }
    };
  }
  return m;
}
var _;
function V() {
  if (_) return p;
  _ = 1, p.__esModule = !0, p.default = void 0;
  var e = n(R());
  function n(t) {
    return t && t.__esModule ? t : { default: t };
  }
  var r = (0, e.default)("local");
  return p.default = r, p;
}
var j = V();
const x = /* @__PURE__ */ D(j);
var q = -1;
function M(e, n) {
  var r = n || {}, t = r.debug;
  return function(s, i) {
    if (!s)
      return c.env.NODE_ENV !== "production" && t && console.log("redux-persist: no inbound state, skipping migration"), Promise.resolve(void 0);
    var o = s._persist && s._persist.version !== void 0 ? s._persist.version : q;
    if (o === i)
      return c.env.NODE_ENV !== "production" && t && console.log("redux-persist: versions match, noop migration"), Promise.resolve(s);
    if (o > i)
      return c.env.NODE_ENV !== "production" && console.error("redux-persist: downgrading version is not supported"), Promise.resolve(s);
    var u = Object.keys(e).map(function(f) {
      return parseInt(f);
    }).filter(function(f) {
      return i >= f && f > o;
    }).sort(function(f, d) {
      return f - d;
    });
    c.env.NODE_ENV !== "production" && t && console.log("redux-persist: migrationKeys", u);
    try {
      var a = u.reduce(function(f, d) {
        return c.env.NODE_ENV !== "production" && t && console.log("redux-persist: running migration for versionKey", d), e[d](f);
      }, s);
      return Promise.resolve(a);
    } catch (f) {
      return Promise.reject(f);
    }
  };
}
function l(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? l = function(r) {
    return typeof r;
  } : l = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, l(e);
}
function O(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function b(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? O(r, !0).forEach(function(t) {
      A(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : O(r).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function A(e, n, r) {
  return n in e ? Object.defineProperty(e, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = r, e;
}
function C(e, n, r, t) {
  var s = t.debug, i = b({}, r);
  return e && l(e) === "object" && Object.keys(e).forEach(function(o) {
    if (o !== "_persist") {
      if (n[o] !== r[o]) {
        c.env.NODE_ENV !== "production" && s && console.log("redux-persist/stateReconciler: sub state for key `%s` modified, skipping.", o);
        return;
      }
      if (W(r[o])) {
        i[o] = b({}, i[o], {}, e[o]);
        return;
      }
      i[o] = e[o];
    }
  }), c.env.NODE_ENV !== "production" && s && e && l(e) === "object" && console.log("redux-persist/stateReconciler: rehydrated keys '".concat(Object.keys(e).join(", "), "'")), i;
}
function W(e) {
  return e !== null && !Array.isArray(e) && l(e) === "object";
}
const E = 0, $ = {
  [E]: (e) => ({ ...w, ...e })
}, F = {
  key: "root",
  debug: !0,
  storage: x,
  version: E,
  stateReconciler: C,
  migrate: M($, { debug: !0 })
}, G = N(F, P), L = S({
  reducer: { app: G },
  middleware: (e) => e({
    serializableCheck: !1
  })
}), H = I(L);
export {
  H as PersistedStore,
  L as Store
};
